import { render, staticRenderFns } from "./LogoMain.vue?vue&type=template&id=c1801f88&"
import script from "./LogoMain.vue?vue&type=script&lang=ts&"
export * from "./LogoMain.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports